import script from "./PharmacyProductTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PharmacyProductTable.vue?vue&type=script&setup=true&lang=js"

import "./PharmacyProductTable.vue?vue&type=style&index=0&id=86014ea0&lang=css"

const __exports__ = script;

export default __exports__